export enum PricebookCategory {
  REGULAR = 'REGULAR',
  AFFILIATE = 'AFFILIATE',
}

// Radio button options for category selector
export const PRICEBOOK_CATEGORY_OPTIONS = {
  [PricebookCategory.REGULAR]: 'Regular Pricebook',
  [PricebookCategory.AFFILIATE]: 'Affiliate Pricebook',
};

// Category-specific UI labels — ADD NEW CATEGORIES HERE
export const PRICEBOOK_CATEGORY_LABELS = {
  [PricebookCategory.REGULAR]: {
    ASSIGN_TO: 'Assigned to company',
    ASSIGN_TO_WAREHOUSE: 'Assigned to warehouse',
    ASSIGN_TO_COUNTRY: 'Assigned to country',
    COMPANY_USER: 'Company user',
    MODAL_TITLE_COMPANY: 'New company pricebook',
    MODAL_TITLE_GEOGRAPHY: 'New geography pricebook',
    MODAL_TITLE_REFERENCE: 'New reference pricebook',
    DEFAULT_USER_OPTION: 'All company members',
  },
  [PricebookCategory.AFFILIATE]: {
    ASSIGN_TO: 'Affiliate company',
    ASSIGN_TO_WAREHOUSE: 'Assigned to warehouse',
    ASSIGN_TO_COUNTRY: 'Assigned to country',
    COMPANY_USER: 'Affiliate user',
    MODAL_TITLE_COMPANY: 'New affiliate company pricebook',
    MODAL_TITLE_GEOGRAPHY: 'New affiliate geography pricebook',
    MODAL_TITLE_REFERENCE: 'New affiliate reference pricebook',
    DEFAULT_USER_OPTION: 'All affiliate members',
  },
};

export const getCategoryLabels = (category: PricebookCategory) =>
  PRICEBOOK_CATEGORY_LABELS[category] || PRICEBOOK_CATEGORY_LABELS[PricebookCategory.REGULAR];
